if ($("#js-filter-block-open")) {
  $("#js-filter-block-open").on("click", function () {
    $("#js-filter-block-mobile").css({ opacity: "1", left: "0" });
    $("body").addClass("no-scroll");
  });

  $("#js-filter-block-close").on("click", function (e) {
    e.preventDefault();
    $("#js-filter-block-mobile").css({ opacity: "0", left: "-100%" });
    $("body").removeClass("no-scroll");
  });
}

// Determine whether or not the checkbox should be disabled
function toggleTagState() {
  const tags = document
    .querySelector("#js-collection-listings")
    .getAttribute("data-tags");

  document.querySelectorAll('[name="filter-checkbox"]').forEach((elem) => {
    const value = $(elem).val();
    if (!tags.includes(value)) {
      $(elem).prop("disabled", true);
      $(elem).prop("checked", false);
    } else {
      $(elem).prop("disabled", false);
    }
  });
}

function handleFilterChange(e) {
  const collectionHandle = document.getElementById("js-collection-listings")
    .dataset.collection;
  let tags = [];
  function updateUrl() {
    document
      .querySelectorAll('[name="filter-checkbox"]:checked')
      .forEach((elem) => {
        tags.push(elem.value.split(" ").join("-"));
      });

    if ($("#js-filter-block-open")) {
      $("#js-filter-block-mobile").css({ opacity: "0", left: "-100%" });
      $("body").removeClass("no-scroll");
    }

    return tags.join("+");
  }

  const url = `${
    window.location.origin
  }/collections/${collectionHandle}/${updateUrl()}`;

  // Set loading state
  $(".js-filter-loading").show();
  $.get(url)
    .done(function (res) {
      const html = $(res);
      const products = $("#js-collection-wrap", html);

      if (products.length > 0) {
        if (products[0].children.length > 0) {
          $("#js-collection-wrap").html($(products).html());
          $(".collection__filter-results").html(
            $(res).find(".collection__filter-results").html()
          );
          $(".collection__paginate").html(
            $($(products)).find(".collection__paginate").html()
          );
          toggleTagState();
          history.replaceState(tags, "", url);
        } else {
          $("#js-collection-wrap").html(`
            <div>
              <h2>
                We're sorry!
              </h2>
              <p>
                We couldn't find any products that match your search criteria.
              </p>
            </div>
          `);
        }
      }
      // Unset loading state
      $(".js-filter-loading").hide();
    })
    .catch(function (err) {
      console.error("There was an error", err);
    });
}

function getSortOption() {
  let value = "";
  document.querySelectorAll('[name="radio-sort"]').forEach((elem) => {
    if (elem.checked) {
      value = elem.getAttribute("value");
    }
  });
  return value;
}

function handleSort() {
  const { origin, pathname } = window.location;
  const url = `${origin}${pathname}?sort_by=${getSortOption()}`;
  $.get(url)
    .done(function (res) {
      const html = $(res);
      const products = $("#js-collection-wrap", html);

      if (products.length > 0) {
        if (products[0].children.length > 0) {
          $("#js-collection-wrap").html($(products).html());
          history.replaceState(getSortOption(), "", url);

          $(".collection__paginate").html(
            $($(products)).find(".collection__paginate").html()
          );
        } else {
          $("#js-collection-wrap").html(`
            <div>
              <h2>
                We're sorry!
              </h2>
              <p>
                We couldn't find any products that match your search criteria.
              </p>
            </div>
          `);
        }
      }
    })
    .catch(function (err) {
      console.error("There was an error", err);
    });
}

document.querySelectorAll('[name="radio-sort"]').forEach((elem) => {
  elem.addEventListener("change", handleSort);
});

if ($("#shopify-section-filter-block").length > 0) {
  $(function () {
    toggleTagState();

    const pathArray = window.location.pathname.split("/");
    const appliedTags = pathArray[pathArray.length - 1].split("+");
    const appliedSort = window.location.search.substring(1).split("&");

    appliedSort.forEach(function (value) {
      document.querySelectorAll('[name="radio-sort"]').forEach((elem) => {
        elem.checked = value.includes(elem.value);
      });
    });

    document.querySelectorAll('[name="filter-checkbox"]').forEach((elem) => {
      elem.checked = appliedTags.includes(elem.value);
    });
  });

  document.querySelectorAll('[name="filter-checkbox"]').forEach((elem) => {
    elem.addEventListener("change", handleFilterChange);
  });
}

// @TODO - understand why this doesn't update the checked UI
if (window.location.pathname.includes("/collections/")) {
  const pathname = window.location.pathname.split("/");
  let activeTags = pathname[pathname.length - 1];
  activeTags = activeTags.split("+");

  document.querySelectorAll('[name="filter-checkbox"]').forEach((elem) => {
    const value = $(elem).val().split(" ").join("-");

    if (activeTags.includes(value)) {
      $(elem).prop("checked", true);
    }
  });
}

if ($(".js-remove-filters").length > 0) {
  $(".js-remove-filters").on("click", (e) => {
    e.preventDefault();
    const collectionHandle = document.getElementById("js-collection-listings")
      .dataset.collection;

    const url = `${window.location.origin}/collections/${collectionHandle}`;

    window.location.href = url;
  });
}
